import { render, staticRenderFns } from "./deliveryCharge.vue?vue&type=template&id=347e6db7&scoped=true&"
import script from "./deliveryCharge.vue?vue&type=script&lang=js&"
export * from "./deliveryCharge.vue?vue&type=script&lang=js&"
import style0 from "./deliveryCharge.vue?vue&type=style&index=0&id=347e6db7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347e6db7",
  null
  
)

export default component.exports